import React from 'react';
import { MapPinIcon, ClockIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Section, SectionHeading } from '../components/Section';
import { Reveal } from '../components/Reveal';
import { LinkButton } from '../components/Button';
import { ClosingCTA } from '../components/ClosingCTA';
import { liveCities, plannedCities } from '../data/cities';
export function Locations() {
  return <main data-id="element-360" data-mp="1juw4jyq6ujl4">
      <PageHeader eyebrow="Locations" title="Founded in Bengaluru. First branch in Chennai. Seven more cities on the way." lede="MeraBucket began in Bengaluru in 2026 and opened its first branch in Chennai the same year. We will only add a city once we have found a senior adviser prepared to live there — a family deserves someone local, not a visiting salesperson." data-id="element-361" data-mp="1jumbu3drdybq" />

      <Section data-id="element-362" data-mp="1120mm1xcx604">
        <SectionHeading eyebrow="Open now" title="Where you can meet us in person." description="Both offices work from the same research, the same approved shelf and the same reporting." data-id="element-363" data-mp="111if2958v5cw" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-364" data-mp="2wqc72bdqs0kt">
          {liveCities.map((city, index) => <Reveal key={city.name} delay={index * 0.05} data-id="element-365" data-mp="31gsixr1wze52" data-mpi={index}>
              <article className="flex h-full flex-col rounded-sm border border-gold/35 bg-paper p-6 sm:p-8" data-id="element-366" data-mp="31jf0mjiira10">
                <div className="flex items-baseline justify-between gap-4" data-id="element-367" data-mp="36i82feog1clc">
                  <h3 className="font-serif text-[1.6rem] text-charcoal" data-id="element-368" data-mp="28uhjwktyhlad">
                    {city.name}
                    <span className="ml-2 align-middle text-sm font-normal text-charcoal-400" data-id="element-369" data-mp="2dtu4t019oiab">
                      {city.state}
                    </span>
                  </h3>
                  <span className="shrink-0 text-xs text-gold-dark" data-id="element-370" data-mp="2mtzczceabkpj">Open since {city.year}</span>
                </div>

                <p className="mt-4 text-[0.95rem] leading-relaxed text-charcoal-600" data-id="element-371" data-mp="3u82fnxcod364">{city.blurb}</p>

                <div className="mt-6 flex gap-2.5 border-t border-line pt-5" data-id="element-372" data-mp="249zp3t8c6yy">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-373" data-mp="1z19t4ndgng9c" />
                  <div data-id="element-374" data-mp="1u38ce93ibt11">
                    <p className="text-sm font-medium text-charcoal" data-id="element-375" data-mp="1u5uie4ar20h5">{city.lead}</p>
                    <p className="mt-0.5 text-xs text-charcoal-400" data-id="element-376" data-mp="282q52zjxbqfo">
                      Meetings at your home, your office, or ours
                    </p>
                  </div>
                </div>

                <div className="mt-auto pt-6" data-id="element-377" data-mp="1ff3qkw95r1e1">
                  <LinkButton to="/contact" data-id="element-378" data-mp="1bds7zaopbgfc">Meet your local adviser</LinkButton>
                </div>
              </article>
            </Reveal>)}
        </div>
      </Section>

      <Section tone="paper" data-id="element-379" data-mp="1ke6ycogivlpp">
        <SectionHeading eyebrow="Opening next" title="The cities we are building towards." description="Families in these cities can start with us now — we travel, and you will be on the same research and reporting from day one." data-id="element-380" data-mp="1kcvtsmf969xj" />

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-381" data-mp="33cv17bi13u54">
          {plannedCities.map((city, index) => <Reveal as="li" key={city.name} delay={Math.min(index, 5) * 0.04} data-id="element-382" data-mp="383lb921egl65" data-mpi={index}>
              <div className="flex h-full flex-col rounded-sm border border-line bg-cream p-6" data-id="element-383" data-mp="2ucgfwc52ef1m">
                <div className="flex items-baseline justify-between gap-3" data-id="element-384" data-mp="2zarmme02c9fm">
                  <h3 className="font-serif text-h3 text-charcoal" data-id="element-385" data-mp="2z8n9d5g9xy2o">{city.name}</h3>
                  <span className="flex shrink-0 items-center gap-1.5 text-xs text-charcoal-400" data-id="element-386" data-mp="3myhndqcbxsoi">
                    <ClockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-387" data-mp="3r0381xv3vb99" />
                    Target {city.year}
                  </span>
                </div>
                <p className="mt-1 text-xs uppercase tracking-wider text-charcoal-400" data-id="element-388" data-mp="3i07rtemp0q2d">
                  {city.state}
                </p>
                <p className="mt-4 text-[0.925rem] leading-relaxed text-charcoal-600" data-id="element-389" data-mp="21plxdkrt5pqs">{city.blurb}</p>
                <p className="mt-auto pt-5 text-xs text-charcoal-400" data-id="element-390" data-mp="26jzmj5fvn0n0">{city.lead}</p>
              </div>
            </Reveal>)}
        </ul>
      </Section>

      <ClosingCTA eyebrow="Somewhere else" title="Your city is not on the list yet." body="Tell us where you are. If we cannot serve you well from Bengaluru or Chennai today, we will say so plainly rather than take the mandate." data-id="element-391" data-mp="2h4habb79nbfc" />
    </main>;
}